import React from "react";

export default function PageItem({ number, getClick, active }) {
  return (
    <div
      className={`flex h-6 w-6 cursor-pointer items-center justify-center space-x-5 `}
      onClick={() => {
        getClick(number);
      }}
    >
      <p
        className={`${
          active === number ? "opacity-100" : "opacity-30"
        } font-sans text-center text-md font-bold underline underline-offset-4 decoration-2 text-[#142D59]`}
      >
        {number}
      </p>
    </div>
  );
}
